var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"bg-white sticky-footer"},[_c('div',{staticClass:"container my-auto"},[_c('div',{staticClass:"text-center my-auto copyright"},[_c('span',[_vm._v("Copyright © Four Brains 2021 - Versión: "+_vm._s(_vm.version))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }